import { Text, useTheme } from "native-base";
import React from "react";
import {
	Image,
	Linking,
	Platform,
	SafeAreaView,
	StyleSheet,
	View,
	Pressable,
} from "react-native";
import Caution from "../../../assets/caution.png";
// Config.
import variables from "../../config/vars";
import { getBrandSupportNumber, isWeb } from "../../utils/utils";

const NoConfigScreen = ({ navigation }) => {
	const { colors } = useTheme();
	const styles = makeStyles(colors);

	const dialCall = (number) => {
		let phoneNumber = "";
		if (Platform.OS === "android") {
			phoneNumber = `tel:${number}`;
		} else {
			phoneNumber = `telprompt:${number}`;
		}
		Linking.openURL(phoneNumber);
	};

	return (
		<SafeAreaView style={{ flex: 1, backgroundColor: "rgb(242, 242, 242)" }}>
			<View style={styles.imageContainer}>
				<Image
					resizeMode="contain"
					style={styles.image}
					source={{
						uri: isWeb() ? Caution : Image.resolveAssetSource(Caution).uri,
					}}
				/>
			</View>
			<View style={styles.buttonContainer}>
				<Text style={styles.offlineTextHeader}>
					Unable to load the required incentive programme
				</Text>
				<Pressable onPress={() => dialCall(getBrandSupportNumber())}>
					<Text style={styles.offlineText}>
						{`Please contact ${getBrandSupportNumber()}`}
					</Text>
				</Pressable>
			</View>
		</SafeAreaView>
	);
};

const makeStyles = (colors) =>
	StyleSheet.create({
		imageContainer: {
			flex: 4,
			alignItems: "center",
			justifyContent: "center",
			marginTop: 10,
		},
		buttonContainer: {
			flex: 2,
			padding: variables.padding_XSmall,
			justifyContent: "center",
		},
		button: {
			backgroundColor: colors.primary["400"],
			alignItems: "center",
			justifyContent: "center",
			padding: variables.padding_Medium,
			borderRadius: variables.borderRadius,
			flexDirection: "row",
			marginHorizontal: variables.marginHorizontal_Small,
		},
		image: {
			height: variables.baseHeight * 30,
			width: variables.baseWidth * 30,
		},
		buttonText: {
			fontSize: variables.fontSize_Medium,
			fontWeight: "700",
			color: colors.primary["100"],
			marginRight: 10,
		},
		offlineText: {
			fontSize: variables.fontSize_Large,
			fontWeight: "600",
			color: colors.primary["900"],
			padding: variables.padding_Small,
			alignSelf: "center",
			textAlign: "center",
		},
		offlineTextHeader: {
			fontSize: variables.fontSize_XLarge,
			fontWeight: "700",
			color: colors.primary["900"],
			alignSelf: "center",
			textAlign: "center",
		},
	});

export default NoConfigScreen;
